import styled from 'styled-components';

export const FilterFormContainer = styled.div`
    margin: 0 0 30px;

    label {
        margin: 0;
    }

    .select {
        height: 44px;
        margin: 0 0 0 10px;
        padding-left: 5px;
    }

    .nombre-partenaires {
        font-size: 18px;

        strong {
            color: ${props => props.theme.directoryPartnersCountTextColor};
        }
    }

    .filtre-conteneur {
        margin: 0 0 0 auto;

        .bt-az {
            height: 44px;
            line-height: 45px;
            padding: 0 18px;
            margin: 0 40px 0 20px;
            border-radius: 3px;
        }
    }

    #annuaire-rubriques-container,
    #tri-container {
        margin-left: 10px;
    }

    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
            props.theme.large}) {
        .filtre-conteneur {
            margin-top: 20px;
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        .nombre-partenaires {
            font-size: 15px;
        }
        .filtre-conteneur {
            padding: 20px;
            margin: 20px 0 0;
            background: ${props => props.theme.directoryFilterContainerColor};
            justify-content: space-between;
        }
        .filtre-conteneur .select {
            flex: 1 auto;
            margin: 5px 0 5px 0;
        }
        .filtre-conteneur .bt-az {
            margin: 0 10px 0 0;
        }
        #annuaire-rubriques-container {
            margin: 0;
            width: 100%;
        }
        #tri-container {
            margin: 0;
            flex: 1 0 auto;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/FilterComponentStyle.js